import React, { useState } from 'react';
import './style.css';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { PopupModal } from '../../../Modals/Index';
const Index = ({ alt, setStateFalse, setImage, image, text }) => {
    const [modal, setModal] = useState(false);
    const selectImage = () => {
        setImage(image);
        setStateFalse();
    };
    return (
        <div className="image_component">
            <PopupModal
                setStateFalse={() => {
                    setModal((prev) => !prev);
                }}
                state={modal}
            >
                <div className="image_component_popup">
                    <img src={image} alt="image_component" className="image_component_popup_image" />
                    <p className="image_component_popup_text">{text}</p>
                </div>
            </PopupModal>
            <img src={image} className="image_component_image" alt="library'a item" />
            <div className="image_component_overlay">
                <div className="image_component_overlay_container">
                    {!alt && (
                        <div className="image_component_overlay_container_item">
                            <VisibilityIcon
                                onClick={() => {
                                    setModal((prev) => !prev);
                                }}
                                className="image_component_overlay_container_item_icon"
                            />
                        </div>
                    )}
                    {!alt && (
                        <div className="image_component_overlay_container_item">
                            <DeleteForeverIcon className="image_component_overlay_container_item_icon" />
                        </div>
                    )}
                    {alt && (
                        <div onClick={selectImage} className="image_component_overlay_container_item">
                            <DoneAllIcon className="image_component_overlay_container_item_icon" />
                        </div>
                    )}
                </div>
            </div>
            <p className="image_component_name">{text.length <= 27 ? text : text.slice(0, 25) + '...'}</p>
        </div>
    );
};

export default Index;
